import React, { useEffect } from 'react';
import { useLegalDocumentT } from '../hooks/useLegalDocumentT.ts';
import { CookiesDocumentContent } from '../components/legal/LegalDocumentContents.tsx';
import './css/CookiesPolicyPage.css';

export default function CookiesPolicyPage() {
  const { t, legalLang } = useLegalDocumentT();

  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = legalLang;
    return () => {
      document.documentElement.lang = previous;
    };
  }, [legalLang]);

  return (
    <div className="cookies-policy-page">
      <div className="cookies-policy-container">
        <h1 className="cookies-policy-title">{t('cookiesPolicy.title')}</h1>
        <p className="cookies-policy-updated">{t('cookiesPolicy.lastUpdated')}</p>
        <CookiesDocumentContent t={t} />
      </div>
    </div>
  );
}
